import {Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {InsightsService} from "../../services/insights/insights.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
@Component({
  selector: 'app-pulse-comments',
  templateUrl: './pulse-comments.component.pug',
  styleUrls: ['./pulse-comments.component.scss'],
  standalone: false
})
export class PulseCommentsComponent implements OnInit {
    @ViewChild('commentsSection') commentsSection!: ElementRef;

    isToggled: boolean = false;
    comments: string[] = [];
    comments_loaded:boolean = false;
    paginationCriteria = {
      total: 0,
      rowsPerView: 20,
      currentPage: 1,
    }
    @Input() start!: any;
    @Input() end!: any;
    @Input() request!: any;
    @Input() survey!: any;
    @Input() department!: any;
    ENT_10363_PULSE_RELAUNCH = false;

    constructor( private insightsService: InsightsService, private alertList: AlertBannerService, public permissionService: PermissionsService ) { }

    ngOnInit(): void {
      this.ENT_10363_PULSE_RELAUNCH = this.permissionService.isFeatureActivated('ent-10363-pulse-relaunch');
    }
    
    ngOnChanges(changes: SimpleChanges): void {
      // Check if any of the inputs have changed and ensure it's not the first change
      if ((changes.start && !changes.start.isFirstChange()) ||
          (changes.end && !changes.end.isFirstChange()) ||
          (changes.request && !changes.request.isFirstChange()) ||
          (changes.survey && !changes.survey.isFirstChange()) ||
          (changes.department && !changes.department.isFirstChange()))
      {
       this.updateCurrentPageAndFetchComments()
      }
    }

    toggleAndFetchComments() {
      this.isToggled = !this.isToggled;
      if (this.isToggled) this.fetchComments();
    }

    fetchComments() {
      this.insightsService.getPulseComments(
        this.start, this.end, this.request, this.department, this.survey,
        this.paginationCriteria.rowsPerView, this.paginationCriteria.currentPage
      ).subscribe({
        next: data => {
          this.comments_loaded = true;
          this.comments = data.comments
          this.paginationCriteria.total = data.total;
          this.scrollToTop();
        },
        error: error => {
          console.log(error);
          this.isToggled = !this.isToggled;
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      });
    }

    onPageChange(pageNumber: number) {
     this.paginationCriteria.currentPage = pageNumber;
     this.fetchComments();
    }

    onPageSizeChange(rowsPerView: number) {
      this.paginationCriteria.rowsPerView = rowsPerView;
      this.updateCurrentPageAndFetchComments()
    }

    updateCurrentPageAndFetchComments(){
      // setTimeout to delay currentPage update
      setTimeout(() =>{
        this.paginationCriteria.currentPage = 1;
        this.fetchComments();
        }, 100
      )
    }

    scrollToTop() {
      if (this.commentsSection) this.commentsSection.nativeElement.scrollTop = 0
    }
}
